export const PRODUCTS_INFORMATION = 'ProductsInformation';
